var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShutDownSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12V0H13V12H11ZM0 12C0 6.78516 3.34766 2.33984 8 0.6875V2.84375C4.47266 4.39062 2 7.91016 2 12C2 17.5156 6.48438 22 12 22C17.5156 22 22 17.5156 22 12C22 7.91016 19.5273 4.39062 16 2.84375V0.6875C20.6523 2.33984 24 6.78516 24 12C24 18.6172 18.6172 24 12 24C5.38281 24 0 18.6172 0 12Z",
    fill: "#101E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutDownSvgrepoCom);
export default __webpack_public_path__ + "static/media/shut-down-svgrepo-com.4be8537e1b5ff1e65a1f05f068ee0d11.svg";
export { ForwardRef as ReactComponent };